import { render } from "./BillingHistoryTab.vue?vue&type=template&id=3fc8e5e5&scoped=true&ts=true"
import script from "./BillingHistoryTab.vue?vue&type=script&lang=ts"
export * from "./BillingHistoryTab.vue?vue&type=script&lang=ts"

import "./BillingHistoryTab.vue?vue&type=style&index=0&id=3fc8e5e5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc8e5e5"]])

export default __exports__